import { render } from "./PerfectPlayer.vue?vue&type=template&id=548cb17a"
import script from "./PerfectPlayer.vue?vue&type=script&lang=js"
export * from "./PerfectPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__